/**
 * 非 localhost 环境禁用常见调试快捷键与右键菜单。
 * 本地开发（localhost / 127.0.0.1）不受影响。
 */
function isLocalHost() {
  const host = (location.hostname || "").toLowerCase();
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "0.0.0.0" ||
    host === "[::1]" ||
    host === "::1"
  );
}

function shouldBlockKey(e) {
  const key = (e.key || "").toLowerCase();
  const code = e.keyCode || e.which;
  const ctrl = e.ctrlKey || e.metaKey;

  // F12
  if (code === 123 || key === "f12") return true;

  if (!ctrl) return false;

  // Ctrl/Cmd + S / U / P
  if (["s", "u", "p"].includes(key) || [83, 85, 80].includes(code)) return true;

  // Ctrl/Cmd + Shift + I / J / C / K（开发者工具）
  if (
    e.shiftKey &&
    (["i", "j", "c", "k"].includes(key) || [73, 74, 67, 75].includes(code))
  ) {
    return true;
  }

  return false;
}

export default function disableDebug() {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (isLocalHost()) return;

  document.addEventListener(
    "contextmenu",
    (e) => {
      e.preventDefault();
    },
    true
  );

  document.addEventListener(
    "keydown",
    (e) => {
      if (!shouldBlockKey(e)) return;
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    true
  );

  document.addEventListener(
    "keyup",
    (e) => {
      if (!shouldBlockKey(e)) return;
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    true
  );
}
